import React, { useContext as useContextCore } from 'react'
import type { UseGetEvents } from './useGetEvents'
import { useGetEvents } from './useGetEvents'
import type { UseGetTaskLists } from './useGetTaskLists'
import { useGetTaskLists } from './useGetTaskLists'

type TaskCalendarProviderProps = {
  children: React.ReactNode
}

export type TaskCalendarContextType = UseGetEvents & UseGetTaskLists

const TaskCalendarContext = React.createContext<TaskCalendarContextType>({} as TaskCalendarContextType)

export const TaskCalendarProvider = ({ children }: TaskCalendarProviderProps) => {
  const taskListResult = useGetTaskLists()
  const eventsResult = useGetEvents(taskListResult?.list)

  return (
    <TaskCalendarContext.Provider
      value={{
        ...eventsResult,
        ...taskListResult,
      }}
    >
      {children}
    </TaskCalendarContext.Provider>
  )
}

export const useTaskCalendarContext = () => useContextCore(TaskCalendarContext)
